import { z } from 'zod'

import { DateZod, GeoPointZod, GooglePlaceDetailsZod } from '../../common'

const BaseTransportRequestEventZod = z.object({
  timestamp: DateZod,
})

const BaseCustomerTransportRequestEventZod = BaseTransportRequestEventZod.extend({
  geolocation: GeoPointZod,
})

const BaseTeamTransportRequestEventZod = BaseTransportRequestEventZod.extend({
  authorPhoneNumber: z.string().optional(),
})

export const TransportRequestEventZod = z.discriminatedUnion('type', [
  BaseCustomerTransportRequestEventZod.extend({
    type: z.literal('customerUpdateOrigin'),
    placeDetails: GooglePlaceDetailsZod,
  }),
  BaseCustomerTransportRequestEventZod.extend({
    type: z.literal('customerUpdateDestination'),
    placeDetails: GooglePlaceDetailsZod,
  }),
  BaseCustomerTransportRequestEventZod.extend({ type: z.literal('customerValidateOrigin') }),
  BaseCustomerTransportRequestEventZod.extend({ type: z.literal('customerValidateDestination') }),
  BaseCustomerTransportRequestEventZod.extend({ type: z.literal('customerSubmit') }),
  BaseCustomerTransportRequestEventZod.extend({ type: z.literal('customerCancel') }),

  BaseTransportRequestEventZod.extend({
    type: z.literal('sendDonationNotification'),
    reminderNumber: z.number().int().min(1).max(2),
  }),
  BaseTransportRequestEventZod.extend({ type: z.literal('piloteAssignTeam'), teamId: z.string() }),
  BaseTransportRequestEventZod.extend({ type: z.literal('piloteAllocateTeam'), teamId: z.string() }),
  BaseTransportRequestEventZod.extend({ type: z.literal('piloteTeamOnboard'), teamId: z.string() }),
  BaseTransportRequestEventZod.extend({ type: z.literal('piloteUnassignTeam'), teamId: z.string() }),
  BaseTransportRequestEventZod.extend({
    type: z.literal('piloteDonationAmountChanged'),
    teamId: z.string(),
    piloteBeforeDonationAmount: z.number(),
    piloteAfterDonationAmount: z.number(),
  }),

  BaseTeamTransportRequestEventZod.extend({ type: z.literal('teamAccept') }),
  BaseTeamTransportRequestEventZod.extend({ type: z.literal('teamOnboard') }),
  BaseTeamTransportRequestEventZod.extend({ type: z.literal('teamCancel') }),
  BaseTeamTransportRequestEventZod.extend({ type: z.literal('teamArrivedAtPickup') }),
  BaseTeamTransportRequestEventZod.extend({
    type: z.literal('teamComplete'),
    donation: z.number(),
    sendDonationRequest: z.boolean().optional(),
  }),
  BaseTeamTransportRequestEventZod.extend({
    type: z.literal('teamUpdateDestination'),
    placeDetails: GooglePlaceDetailsZod,
  }),
  BaseTeamTransportRequestEventZod.extend({
    type: z.literal('teamReceiveDonation'),
    donation: z.number(),
  }),
  BaseTeamTransportRequestEventZod.extend({
    type: z.literal('teamSendDonationRequest'),
  }),
])

export type TransportRequestEvent = z.infer<typeof TransportRequestEventZod>
